import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { UploadxModule } from 'ngx-uploadx';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { SocketService } from './app/shared/SocketService';
import { HttpConcurrencyInterceptor } from './app/shared/http-concurrency.service';
import { HttpErrorHandlingInterceptor } from './app/shared/http-error-handling-interceptor.service';
import { ResultconferenceGuard } from './app/shared/resultconference.guard';
import { PackService } from './app/shared/services/PackService';
import { PdfAnnotationService } from './app/shared/services/PdfAnnotationService';
import { LayoutService } from './app/shared/services/layout.service';
import { VideoRecordingService } from './app/shared/video-recording.service';
import { WcagComponent } from './app/shared/wcag/wcag.component';
import { WcagService } from './app/shared/wcag/wcag.service';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

// Prevent pinch-zoom on touch devices (moved out of index.html to avoid requiring
// 'unsafe-inline' in the script-src Content-Security-Policy directive).
document.addEventListener('touchmove', function (event: any) {
    if (event.scale !== 1) {
        event.preventDefault();
    }
}, { passive: false });

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(), importProvidersFrom(
            UploadxModule,
            BrowserModule,
            ToastrModule.forRoot(),
            CollapseModule,
            AppRoutingModule
        ),
        WcagComponent,
        WcagService,
        SocketService,
        PackService,
        LayoutService,
        PdfAnnotationService,
        BsModalService,
        ResultconferenceGuard,
        VideoRecordingService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorHandlingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConcurrencyInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideCharts(withDefaultRegisterables()),
        provideAnimations()
    ]
})
    .catch(err => console.error(err));
